import baseAPI from '@/api';
import { Success } from '@/models/success';
import { AxiosResponse } from 'axios';
import {
  PublicKeyCredentialRequestOptionsJSON,
  RegistrationResponseJSON,
} from '@simplewebauthn/browser';
import { AuthLoginRequestDto } from '@starsoft/common/dto';

export async function fetchGeneratePassKeyAuthentication(
  data: Pick<AuthLoginRequestDto, 'email'>,
): Promise<PublicKeyCredentialRequestOptionsJSON> {
  const response: AxiosResponse<PublicKeyCredentialRequestOptionsJSON> =
    await baseAPI.post<PublicKeyCredentialRequestOptionsJSON>(
      '/iam/generate-passkey-authentication',
      data,
    );
  return response.data;
}
